import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { PatronymicTextField } from '~/core/components';
import BaseTextField from '~/core/components/Base/BaseTextField.vue';
import useLocaleStore from '~/stores/useLocaleStore';
import { nameRules, nameRulesCis, surnameRules, surnameRulesCis } from '~/features/Profile/functions';
export default /*#__PURE__*/_defineComponent({
  __name: 'FIOForm',
  props: {
    patronymic: {
      type: String,
      default: ''
    },
    forename: {
      type: String,
      default: ''
    },
    surname: {
      type: String,
      default: ''
    },
    isEmptyPatronymic: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:patronymic', 'update:forename', 'update:surname'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _storeToRefs = storeToRefs(useLocaleStore()),
      isCis = _storeToRefs.isCis;
    var syncedPatronymic = computed({
      get: function get() {
        return props.patronymic;
      },
      set: function set(val) {
        emit('update:patronymic', val);
      }
    });
    var syncedForename = computed({
      get: function get() {
        return props.forename;
      },
      set: function set(val) {
        emit('update:forename', val);
      }
    });
    var syncedSurname = computed({
      get: function get() {
        return props.surname;
      },
      set: function set(val) {
        emit('update:surname', val);
      }
    });
    var localizedNameRules = computed(function () {
      return isCis.value ? nameRulesCis : nameRules;
    });
    var localizedSurnameRules = computed(function () {
      return isCis.value ? surnameRulesCis : surnameRules;
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      isCis: isCis,
      syncedPatronymic: syncedPatronymic,
      syncedForename: syncedForename,
      syncedSurname: syncedSurname,
      localizedNameRules: localizedNameRules,
      localizedSurnameRules: localizedSurnameRules,
      PatronymicTextField: PatronymicTextField,
      BaseTextField: BaseTextField
    };
  }
});